function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M61.286 36.775v-3.042 3.042H0v-13.69C0 19.729 2.82 17 6.286 17h18.857c.368 0 .723.125 1.006.351l8.992 7.255H55c3.466 0 6.285 2.729 6.285 6.085v6.084z",
  id: "catalog_1_svg__b"
}), /*#__PURE__*/React.createElement("path", {
  id: "catalog_1_svg__c",
  d: "M0 .08h44.932v32.35H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.372 10.569L13.386.582a1.99 1.99 0 00-2.813 0L.582 10.569a1.99 1.99 0 000 2.813 1.99 1.99 0 002.813 0l6.593-6.59v23.213a1.99 1.99 0 003.979 0V6.793l6.592 6.589a1.983 1.983 0 002.813 0 1.99 1.99 0 000-2.813",
  id: "catalog_1_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.35 38.564c1.102-3.667 5.1-6.64 8.924-6.64h49.2c3.827 0 6.23 3.028 5.37 6.75l-7.3 31.587c-.861 3.728-4.663 6.75-8.487 6.75H7.723c-3.826 0-6.033-2.975-4.932-6.64l9.559-31.807z",
  id: "catalog_1_svg__g"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-38.7%",
  y: "-38.7%",
  width: "177.3%",
  height: "177.3%",
  filterUnits: "objectBoundingBox",
  id: "catalog_1_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12.5,
  "in": "SourceGraphic"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 15)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#8F3EA1",
  filter: "url(#catalog_1_svg__a)",
  cx: 91.5,
  cy: 71.5,
  r: 48.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 91,
  cy: 60,
  r: 60
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.795 44.84h60.543v38.154a6.934 6.934 0 01-6.93 6.934H59.726c-3.828 0-6.93-3.1-6.93-6.934V44.84z",
  fill: "#E0C28B"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.795 15.038)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#catalog_1_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#E0C28B",
  xlinkHref: "#catalog_1_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M103.932 24.387H59v-7.189c0-.662.536-1.198 1.198-1.198h42.536c.662 0 1.198.536 1.198 1.198v7.19z",
  fill: "#0084DB"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(59 24.308)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "catalog_1_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#catalog_1_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M43.734 32.351H1.198A1.198 1.198 0 010 31.153V0h44.932v31.153c0 .662-.536 1.198-1.198 1.198",
  fill: "#F4F4F4",
  mask: "url(#catalog_1_svg__d)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M63.505 18.097a2.097 2.097 0 110 4.194 2.097 2.097 0 010-4.194",
  fill: "#E1E6E9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.095 18.097a2.097 2.097 0 110 4.194 2.097 2.097 0 010-4.194",
  fill: "#44C94E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.685 18.097a2.097 2.097 0 110 4.194 2.097 2.097 0 010-4.194",
  fill: "#F9BA48"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.725 21.991H85.497a1.797 1.797 0 110-3.595h14.228a1.797 1.797 0 010 3.595",
  fill: "#EBF0F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.322 30.538c5.446 0 9.861 4.415 9.861 9.861 0 5.446-4.415 9.861-9.86 9.861-5.447 0-9.861-4.415-9.861-9.86 0-5.447 4.414-9.862 9.86-9.862",
  fill: "#913FA3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M86.515 39.599l-7.5-4.723a.946.946 0 00-1.45.8v9.447a.946.946 0 001.45.8l7.5-4.723a.946.946 0 000-1.601",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(107.016 18)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "catalog_1_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#catalog_1_svg__e"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#913FA3",
  xlinkHref: "#catalog_1_svg__e"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#591867",
  mask: "url(#catalog_1_svg__f)",
  d: "M9.271 21.91h5.478v6.573H9.271z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52 14)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#catalog_1_svg__g"
}), /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0.5,
  fill: "#F9BA48",
  xlinkHref: "#catalog_1_svg__g"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(180 80 67.5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M154.486 88c.65 0 1.176.526 1.176 1.176v3.134h3.135c.606 0 1.105.46 1.17 1.048l.006.128c0 .65-.526 1.176-1.176 1.176h-3.135v3.135c0 .606-.458 1.105-1.047 1.17l-.129.006c-.649 0-1.175-.526-1.175-1.176l-.001-3.135h-3.134a1.176 1.176 0 01-1.17-1.047l-.006-.129c0-.649.526-1.175 1.176-1.175l3.134-.001v-3.134c0-.606.46-1.105 1.048-1.17z",
  fill: "#F9BA48",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.986 125c.59 0 1.069.478 1.069 1.069v2.848l2.85.001c.55 0 1.004.417 1.062.952l.006.116c0 .59-.478 1.069-1.069 1.069h-2.849v2.85c0 .55-.417 1.004-.952 1.062l-.117.006c-.59 0-1.068-.478-1.068-1.069l-.001-2.849H5.069c-.551 0-1.005-.417-1.063-.952L4 129.986c0-.59.478-1.068 1.069-1.068l2.848-.001.001-2.848c0-.551.417-1.005.952-1.063z",
  fill: "#DA4D7A",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EC4D4D",
  cx: 131.5,
  cy: 37.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#0086D8",
  cx: 126.5,
  cy: 127.5,
  r: 2.5
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#44C94E",
  strokeWidth: 2,
  cx: 82.5,
  cy: 3.5,
  r: 3.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#E57339",
  cx: 3.5,
  cy: 37.5,
  r: 3.5
})));

function SvgCatalog1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 173,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/catalog_1.07dab68f.svg";
export { SvgCatalog1 as ReactComponent };